import { IItemMenu } from '../models/i-item-menu';

export const MenuItemList: IItemMenu[] = [
  {
    displayContent: 'Informacje',
    link: '/informacje'
  },
  {
    displayContent: 'Zaszyfruj',
    link: '/zaszyfruj'
  },
  {
    displayContent: 'Odszyfruj',
    link: '/odszyfruj'
  }
];
